class DataLayer  {

    constructor() {
        if (!window.dataLayer) {
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', window.gtmCode);
        }
        this.dataLayer = window.dataLayer || [];
    }


    async push(data) {
        this.dataLayer.push(data);
    }

    clear() {
       // window.dataLayer.push(function() {
            //this.reset();
         // }); // Clear the previous ecommerce object.
    }

}